import styled from "styled-components";

export const ErrorWrapper = styled.span`
    font-size: 13px;
    font-weight: 600;
    line-height: 22px;
    display: block;
    color: red;
`;